import { Box } from "@chakra-ui/react";
import { AudioPlayer } from "components";
import { useLocation } from "react-router-dom";
import "./App.css";
import LanguageProvider from "languages/LanguageProvider";
import BackgroundView from "components/views/BackgroundView";
import AppStack from "features/AppStack";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const location = useLocation();
  const isPlayer =
    location.pathname.includes("app") && !location.pathname.includes("Radio");

  // console.log("=-=-=", location.pathname.includes("Radio"));

  return (
    <LanguageProvider>
      <BackgroundView justifyContent={"space-between"}>
        <Box
          w="full"
          overflow={"hidden"}
          h={isPlayer ? "calc(100% - 100px)" : "100%"}
        >
          <GoogleOAuthProvider clientId="1047825202135-gd8b17rh6jik7j8nk47hnj7ogkd2lvlm.apps.googleusercontent.com">
            <AppStack />
          </GoogleOAuthProvider>
        </Box>
        {isPlayer && <AudioPlayer />}
      </BackgroundView>
    </LanguageProvider>
  );
}

export default App;
